module.exports = __webpack_public_path__ + "img/gift-2.8171e300.png";